import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  TextField,
  Alert,
} from "@mui/material";
import { Email as EmailIcon, Forum as DiscordIcon } from "@mui/icons-material";
import DashboardLayout from "../../layouts/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import MDButton from "../../components/MDButton";

const SupportPage = () => {
  const handleContactSupport = (method) => {
    // Implement support contact logic here
    console.log(`Contacting support via ${method}`);
  };

  return (
    <DashboardLayout>
      <MDBox mb={3}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <Card>
              <CardContent>
                <MDTypography variant="h4" fontWeight="medium" mb={2}>
                  Support & Hilfe
                </MDTypography>
                <Typography variant="body1" color="textSecondary" mb={4}>
                  Haben Sie Fragen oder benötigen Sie Unterstützung? Unser
                  Support-Team steht Ihnen gerne zur Verfügung.
                </Typography>

                <Grid container spacing={3} justifyContent="center">
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Card
                      variant="outlined"
                      sx={{ height: "100%", textAlign: "center", p: 2 }}
                    >
                      <EmailIcon
                        sx={{ fontSize: 60, color: "#1976d2", mb: 2 }}
                      />
                      <Typography variant="h6" gutterBottom>
                        E-Mail Support
                      </Typography>
                      <Typography variant="body2" color="textSecondary" mb={2}>
                        Schreiben Sie uns eine E-Mail. Wir antworten in der
                        Regel innerhalb von 24 Stunden.
                      </Typography>
                      <MDButton
                        variant="outlined"
                        color="info"
                        href="mailto:support@lage-beauty.de"
                      >
                        E-Mail senden
                      </MDButton>
                    </Card>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <Card
                      variant="outlined"
                      sx={{ height: "100%", textAlign: "center", p: 2 }}
                    >
                      <DiscordIcon
                        sx={{ fontSize: 60, color: "#5865F2", mb: 2 }}
                      />
                      <Typography variant="h6" gutterBottom>
                        Discord Community
                      </Typography>
                      <Typography variant="body2" color="textSecondary" mb={2}>
                        Treten Sie unserem Discord-Server bei für direkten
                        Austausch und Support.
                      </Typography>
                      <MDButton
                        variant="outlined"
                        color="info"
                        href="https://discord.gg/FhNm3uFN"
                        target="_blank"
                      >
                        Discord beitreten
                      </MDButton>
                    </Card>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Card>
              <CardContent>
                <MDTypography variant="h5" fontWeight="medium" mb={2}>
                  Häufig gestellte Fragen (FAQ)
                </MDTypography>
                {/* Add FAQ Accordion or list here if needed */}
                <Typography variant="body2" color="textSecondary">
                  Hier finden Sie Antworten auf die häufigsten Fragen. (Inhalt
                  folgt)
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default SupportPage;
